export const LOGIN = '/login';
export const SUBSCRIBED_USERS = '/subscribed-users';
export const INVITED_USERS = '/invited-users';
export const DASHBOARD = '/dashboard';
export const ORGANIZATIONS = '/organizations';
export const CANCELLATIONS = '/cancellations';
export const AUTO_PLAN_FEEDBACK = '/auto-plan-feedback';
export const ANALYTICS = '/analytics';
export const RESET_TRIALS = '/reset-trials';
export const FIRST_WEEK = '/first-week';
export const USAGE = '/usage';
export const UNREDEEMED_USERS = '/unredeemed-users';
export const SCHEDULED_EMAILS = '/scheduled-emails';
export const PENDING_MEMBERSHIPS = '/pending-memberships';
export const COACHES = '/coaches';
export const SYLLABUS_IMPORTS = '/syllabus-imports';
export const AI_USAGE = '/ai-usage';
